import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DataSourcesService } from "./data-sources.service";
import { BehaviorSubject, forkJoin, Observable, of, Subject } from "rxjs";
import { map, mergeMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class StepperSharedDataService {

  firstClick = new BehaviorSubject(false);
  firstClick$: Observable<boolean> = this.firstClick.asObservable()
  constructor(
    private datasourceService: DataSourcesService,
    private http: HttpClient
  ) {}
  private selectedContract;
  private selectedJourney;
  private selectedContractBeforeNavigation;
  pageDestroy$ = new Subject<any>();
  PayBillInfo;
  activationPageDetails;

  setSelectedContract(contract) {
    this.selectedContract = contract;
  }
  get _selectedContract() {
    return this.selectedContract;
  }
  setSelectedJourney(journey) {
    this.selectedJourney = journey;
  }
  get _selectedJourney() {
    return this.selectedJourney;
  }

  setSelectedContractFromNavigation(contract) {
    this.selectedContractBeforeNavigation = contract;
  }

  get _selectedContractBeforeNavigation() {
    return this.selectedContractBeforeNavigation;
  }
  getAllProducts(extraInfo) {
    const data = {
      PaymentMethod: extraInfo.PaymentMethod,
      PageSize: 12,
      PageNo: 1,
      "SearchJson.BusinessLines": extraInfo.BusinessLines,
      // "SearchJson.Channel": 6,
      // code: pricePlanCode
    };
    return this.datasourceService.invokeDataSource(5, data, true);
  }

  getProuduct(dataSourceId, extraInfo, pricePlanCode = "") {
    // this.productDetailsSubject.next(false);
    // paymentMethod 1 , post-paid , 2 pre-paid , BusinessLines 49LTE , 48FTTH
    const data = {
      PaymentMethod: extraInfo.PaymentMethod,
      PageSize: 12,
      PageNo: 1,
      "SearchJson.BusinessLines": extraInfo.BusinessLines,
      // "SearchJson.Channel": 6,
      // code: pricePlanCode
    };

    return this.datasourceService
      .invokeDataSource(dataSourceId.DatasourcePlanDSId, data, true)

      .pipe(
        mergeMap((plan) => {
          const code = plan[0]["code"]
            ? plan[0]["code"]
            : plan[0]["pricePlanCodeNew"];
          const pricePlan = this.getProductPrice(
            dataSourceId,
            code,
            plan[0]["businessLines"]
          ).pipe(
            map((planPrice: any) => {
              return { ...plan[0], ...planPrice[0] };
            })
          );
          return forkJoin(pricePlan);
        })
      );
  }

  getDCMSProuduct(productId) {
    return this.http.post(`/GeneralProduct/GetProductById/${productId}`, {});
  }

  getNewMatrix(pricePlanCodeOld, configType) {
    const data = {
      status: 2,
      isAllowed: 2,
      configType: configType,
      pricePlanCodeOld: pricePlanCodeOld,
    };
    return this.datasourceService.invokeDataSource(3, data, true);
  }

  getProductPrice(dataSourceId, pricePlanCode, businessLines) {
    if (dataSourceId.DatasourceProductPriceDSId) {
      const data = {
        PricePlanCode: pricePlanCode,
        PageSize: 10,
        PageNo: 10,
      };

      return this.datasourceService
        .invokeDataSource(dataSourceId.DatasourceProductPriceDSId, data, true)
        .pipe(
          mergeMap((plan) => {
            let characteristec;
            if (plan) {
              const checkForKeys = plan.pricePlanCode
                ? plan.pricePlanCode
                : plan.productcode;
              characteristec = this.getCharacteristic(
                dataSourceId,
                checkForKeys,
                plan.productcode,
                businessLines
              ).pipe(
                map((characteristec) => {
                  return { ...plan, ...characteristec };
                })
              );
            }
            return forkJoin(characteristec);
          })
        );
    } else {
      return of([null]);
    }
  }

  getCharacteristic(dataSourceId, pricePlanCode, productCode, businessLines) {
    if (dataSourceId.DatasourcecharacteristicDSId) {
      const data = {
        formId: businessLines == "48" ? 548 : 367,
        productCode: productCode,
        pricePlanCode: pricePlanCode,
      };
      return this.datasourceService
        .invokeDataSource(dataSourceId.DatasourcecharacteristicDSId, data, true)
        .pipe(
          mergeMap((plan) => {
            if (plan) {
              return of(plan);
            }
            return forkJoin(plan);
          })
        );
    } else {
      return of([null]);
    }
  }

  addToCart(userId, data) {
    const url = `/customers/${userId}/add-cart-item`;
    return this.http.post(url, data);
  }

  getMappingProduct(obj) {
    return this.http.post("/product/GetMappingProductByAttributeValue", obj);
  }

  addShippingAddress(data) {
    return this.http.post("/checkout/shipping-order", data);
  }

  pageDestroy() {
    this.pageDestroy$.next();
  }

  activateLTE(data) {
    return this.datasourceService.invokeDataSource(45, data, true);
  }

  setActivationPageDetails(data) {
    this.activationPageDetails = data;
  }

  adminLog(
    request,
    err,
    apiName: string,
    functionName: string,
    additionalDetails:any = {}
  ) {
    const message = JSON.stringify({
      Result: err.message ? err.message : err,
      Request: request,
    });

    const additionalInfo = JSON.stringify({
      orderId:additionalDetails.orderId || '',
      workflowInstanceId:additionalDetails.WFId || '',
      ContractNumber:additionalDetails.contarctNumber || ''
    })

    const errorMessage = JSON.stringify(err)

    const data = {
      Module: apiName,
      exception: errorMessage,
      Scope: functionName,
      Message: message,
      AdditionalInfo: additionalInfo,
    };

    return this.http.post("/Logging/LogError", data).subscribe();
  }

  get _activationPageDetails() {
    return this.activationPageDetails;
  }
}
